/* src/app/opportunities/pages/edit-opportunities/edit-opportunities.component.scss */
/*# sourceMappingURL=edit-opportunities.component.css.map */
